import Image from 'next/image';
import { useState } from 'react';

import { useAuthContext } from '@picsart/growth-rc/AuthContext';
import { BreakPoints } from '@picsart/rc/enums';
import useMount from '@picsart/rc/useMount';

import CenteredContent from 'components/CenteredContent';
import Layout from 'components/Layout';

import useNotFoundStyles from './styles';

const img = 'https://cdn140.picsart.com/01531534061961523506.png?q=75&to=crop&r=600x370&type=webp';

const defaultImageProportions = {
  width: 550,
  height: 257,
};

const smallImageProportions = {
  width: 320,
  height: 136,
};

const ErrorNotFound = function ({ isMobile, isWebView }) {
  const { user } = useAuthContext();
  const styles = useNotFoundStyles();

  const [imageSize, setImageSize] = useState(defaultImageProportions);

  useMount(() => {
    const screenSize =
      window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    setImageSize(
      screenSize <= BreakPoints.Medium ? smallImageProportions : defaultImageProportions,
    );
  });

  return (
    <Layout title="Not Found" isMobile={isMobile} isWebView={isWebView}>
      <CenteredContent>
        <div className={styles.main}>
          <Image
            className={styles.img}
            loader={() => img}
            priority
            layout="fixed"
            width={imageSize.width}
            height={imageSize.height}
            src={img}
            blurDataURL="https://cdn140.picsart.com/01531534061961523506.png?q=75&to=crop&r=40x40&type=webp"
            alt="not found image"
            placeholder="blur"
          />
          <h3>Ooops!</h3>
          <p>Seems like this page does not exist </p>
          <a href={user ? '/create' : '/'} className={styles.homeBtn}>
            Go Home
          </a>
        </div>
      </CenteredContent>
    </Layout>
  );
};

export default ErrorNotFound;
